import DealsWidgetBase from "./deals_widget_base";
import iconSpinnerSvg from "../assets/icon__spinner.svg";

export const DealsWidgetSpinnerConfig = {
  componentTypeKey: "DealsWidgetSpinner",
  baseHtmlClass: "deals_widget__spinner",
};

/**
 * Spinner component that displays over the trigger while loading deals.
 * Shows when isOpen && isLoading, hides when data is loaded or panel closes.
 */
export default class DealsWidgetSpinner extends DealsWidgetBase {
  static get config() {
    return DealsWidgetSpinnerConfig;
  }

  constructor(parentComponent) {
    const element = DealsWidgetSpinner.buildElement();

    super(element, parentComponent, DealsWidgetSpinner.config);

    this.triggerElement = parentComponent.triggerElement;

    // Append to trigger so it scales with hover
    this.triggerElement.appendChild(this.element);
  }

  static buildElement() {
    const element = document.createElement("div");
    element.classList.add(DealsWidgetSpinnerConfig.baseHtmlClass);
    element.innerHTML = iconSpinnerSvg;
    return element;
  }

  render() {
    const isOpen = this.readStateMachineValue("isOpen");
    const isLoading = this.readStateMachineValue("isLoading");

    // Show spinner when panel is open and loading
    const shouldShow = isOpen && isLoading;
    this.conditionallySetHtmlClassState(shouldShow, "visible");
  }
}
